import React, { useState, useRef, useEffect } from 'react'
import { Tooltip } from 'antd'
import { useDispatch } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import { getAssessmentListFxn, updateAssessmentViewedFxn } from './action/index'
import { DefaultTablePagination, newFormatDisplayDate } from '../../components/_utils/appUtils'
import AssessmentProfile from './drawer/assessmentProfile'
import { getLoginUser } from '../../request'
import AssessmentAgentProfile from './drawer/agentAssessmentProfile'

const AssessmentComponent = (props) => {
  let { header, callBack, reloadTable } = props
  let currentUser = getLoginUser()
  console.log(currentUser, "currentUsercurrentUsercurrentUser")
  useEffect(() => {
    if (reloadTable) {
      events.refreshTable()
    }
  }, [reloadTable])
  const [total, setTotal] = useState(0)
  const [assessmentProfileDrawer, setAssessmentProfileDrawer] = useState({
    visible: false,
    assessmentData: {}
  })
  const [assessmentProfileAgentDrawer, setAssessmentProfileAgentDrawer] = useState({
    visible: false,
    assessmentData: {}
  })
  const tableRef = useRef()
  const dispatch = useDispatch()
  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let resp = await dispatch(getAssessmentListFxn({
        ...params
      }))
      setTotal(resp.total)
      if (typeof callBack === 'function') {
        callBack(resp.total > 0)
      }
      resolve(resp)
    })
  }

  const events = {
    refreshTable: () => {
      tableRef.current.reload()
    },
    updateAssessmentViewed: async (assessment) => {
      if (assessment && assessment.status == 'pending') {
        let resp = await dispatch(updateAssessmentViewedFxn({ assessmentId: assessment._id }))
        events.refreshTable()
      }
    },
    showAssessmentDrawer: (assessmentData) => {
      setAssessmentProfileDrawer({
        visible: true,
        assessmentData
      })
    },
    hideAssessmentDrawer: (assessmentData) => {
      setAssessmentProfileDrawer({
        visible: false,
        assessmentData: {}
      })
      events.updateAssessmentViewed(assessmentData)
    },

    showAgentAssessmentDrawer: (assessmentData) => {
      setAssessmentProfileAgentDrawer({
        visible: true,
        assessmentData
      })
    },

    hideAgentAssessmentDrawer: () => {
      setAssessmentProfileAgentDrawer({
        visible: false,
        assessmentData: {}
      })
    }
  }


  const columns = [
    {
      title: 'Student Name',
      dataIndex: 'studentDetails',
      key: 'studentDetails',
      render: (text, record) => (
        <div>
          <h5 className={'textCap colorDarkPrimary'}>{record.studentName}</h5>
          <div className={'font13'}>
            DOB:- {newFormatDisplayDate(record.dateOfBirth)} &nbsp;•&nbsp; Passport:- {record.passportNumber}
          </div>
        </div>
      )
    },
    {
      title: 'Assessment Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (val) => {
        return (
          <span>
            {newFormatDisplayDate(val)}
          </span>
        )
      }
    },
    {
      title: 'Contact Per Name',
      dataIndex: 'contactPersonName',
      key: 'contactPersonName',
      render: (text, record) => {
        return (
          <div>
            {text}<br />
            ({record.contactNumber})
          </div>
        )
      }
    },
    {
      title: 'Agent',
      dataIndex: 'agentId',
      key: 'agentId',
      render: (agent, record) => {
        return (
          <div>
            {agent && agent.name ? agent.name : ''}
            <br /> {record.companyName && `(${record.companyName})`}
          </div>
        )
      }
    },
    {
      title: 'Assign To',
      dataIndex: 'assignBy',
      key: 'assignBy',
      render: (text) => {
        return (
          <div>
            {text && text.name ? text.name : ''}
          </div>
        )
      }
    },
    {
      title: 'No Of Asst.',
      dataIndex: 'assessmentCount',
      key: 'assessmentCount',
      width: 100
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      render: (status) => {
        let bgColor = ''
        switch (status.toLowerCase()) {
          case 'pending':
            bgColor = '#FFF8C5'
            break
          case 'viewed':
            bgColor = '#DDEEFF'
            break
          case 'assessed':
            bgColor = '#D9FBE9'
            break
          case 'closed':
            bgColor = '#e6e7e8'
            break
          default:
            bgColor = '#000'
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: '#0070cc',
              padding: '2px 8px',
              borderRadius: '5px',
              fontWeight: 600,
              fontSize: '13px',
              display: 'inline-block',
              textTransform: 'capitalize'
            }}
          >
        {status}
      </span>
        )
      }
    },
    {
      key: 'actions',
      title: 'Actions',
      width: 120,
      render: (text, record) => {
        return <React.Fragment>

          {
            currentUser && currentUser.userType == 'agent' ?
              <Tooltip title='View'>
                <a className={'btn btn-default sm roundNew'}
                   style={{ marginRight: 6 }}
                   onClick={() => events.showAgentAssessmentDrawer(record)}>
                  View
                </a>
              </Tooltip> :
              <Tooltip title='View'>
                <a className={'btn btn-default sm roundNew'}
                   style={{ marginRight: 6 }}
                   onClick={() => events.showAssessmentDrawer(record)}>
                  View
                </a>
              </Tooltip>
          }

        </React.Fragment>

      }
    }
  ]

  return (
    <>
      {header &&
      <div className='table-head d-flex align-items-center'>
        <h5>Uniz Assessments <small>(Total : {total})</small></h5>
        <div className='search-box-table'>
        </div>
      </div>
      }
      <div className='card-body table-responsive'>
        <TableComp columns={columns}
                   apiRequest={apiRequest}
                   ref={tableRef}
                   pagination={DefaultTablePagination()}
        />
      </div>
      {assessmentProfileDrawer.visible ?
        <AssessmentProfile
          {...assessmentProfileDrawer}
          currentUser={currentUser.userType}
          onClose={(assessment) => {
            events.hideAssessmentDrawer(assessment)
            events.refreshTable()

          }}
        /> : null}

      {assessmentProfileAgentDrawer.visible ?
        <AssessmentAgentProfile
          {...assessmentProfileAgentDrawer}
          onClose={(assessment) => {
            events.hideAgentAssessmentDrawer(assessment)
            events.refreshTable()
          }}
        /> : null}
    </>

  )
}

export default AssessmentComponent
